module.exports = __webpack_public_path__ + "img/adf-airforce.77955c5.webp";